const getSyncedComputed = (prop, guardFunc) => ({
	get() {
		return this.fieldDefinition[prop];
	},
	async set(value) {
		const newV = { ...this.fieldDefinition, [prop]: value };
		const isConfirmed = await guardFunc(value);
		if (isConfirmed) {
			this.$emit('onFieldDefinition', newV);
		}
	},
});

const getFieldsDefinition = (name, type = 'string') => ({
	name,
	type,
	is_required: true,
});

const isFieldDefinitionValid = (fieldDef) => fieldDef?.name?.length > 0 && fieldDef?.type?.length > 0;

const FieldDefinitionService = {
	getSyncedComputed,
	getFieldsDefinition,
	isFieldDefinitionValid,
};

export default FieldDefinitionService;
